import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconComponent } from '@shared/components/icon/icon.component';
import { ROUTING_PATH } from '@shared/constants/routingPath';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, RouterLink],
  selector: 'aux-invoice-detail-go-back',
  template: `
    <div
      class="mb-6 flex max-w-max cursor-pointer items-center text-aux-blue-light-200"
      [routerLink]="[invoicesLink]"
    >
      <aux-icon name="ArrowLeft" class="mr-2" />
      <div>Back to Invoices</div>
    </div>
  `,
})
export class InvoiceDetailGoBackComponent {
  invoicesLink = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES}`;
}
